module.exports = __webpack_public_path__ + "4027db7423950750ce06dbc6edce81a6.png";